module.exports = __webpack_public_path__ + "media/gallery/1-8c26cb5f.jpg";